import React from "react";
import { Typography } from "antd";
import GradientButton from "../../../../common/UI/GradientButton";
import { formatCurrency } from "../../../../../utils/currency";
import MY_DEVICES, { STATUS_LABELS } from "../constants";
import type { DeviceFilter, DeviceOrder } from "../types";
import DeviceImage from "./DeviceImage";

const { Text } = Typography;

interface DeviceCardProps {
  order: DeviceOrder;
  stage: DeviceFilter;
  isFocused: boolean;
  canActivate: boolean;
  onActivate: (order: DeviceOrder) => void;
}

const DeviceCard: React.FC<DeviceCardProps> = ({
  order,
  stage,
  isFocused,
  canActivate,
  onActivate,
}) => (
  <div className={`my-devices-card${isFocused ? " focused" : ""}`}>
    <div className="my-devices-card-body">
      <DeviceImage product={order.product} />
      <div className="my-devices-card-info">
        <div className="my-devices-card-title-row">
          <span className="my-devices-card-name">
            {order.product?.name ||
              order.productName ||
              MY_DEVICES.LABELS.DEFAULT_PRODUCT}
          </span>
          <span className={`my-devices-card-status ${stage}`}>
            {STATUS_LABELS[stage]}
          </span>
        </div>
        <Text className="my-devices-card-subtitle">
          {order.product?.brand || MY_DEVICES.LABELS.DEFAULT_BRAND}
          &nbsp;&bull;&nbsp;
          {order.product?.modelNumber || order.productId || "Device"}
          &nbsp;&bull;&nbsp;
          {order.product?.productType || MY_DEVICES.LABELS.DEFAULT_TYPE}
        </Text>
      </div>
    </div>

    <div className="my-devices-card-price">
      {formatCurrency(order.amount || 0, order.currency)}
    </div>

    <div className="my-devices-card-order-id">
      {MY_DEVICES.LABELS.ORDER_PREFIX}{" "}
      <span title={order.id}>{order.id}</span>
    </div>

    {canActivate && (
      <GradientButton
        block
        className="my-devices-activate-btn"
        onClick={() => onActivate(order)}
      >
        {MY_DEVICES.LABELS.ACTIVATE}
      </GradientButton>
    )}
  </div>
);

export default DeviceCard;
